/**
 * Created by Administrador on 11/04/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('itineraryList', {
                parent: 'app',
                url: '/itinerary/list?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/flightControl/itinerary/itineraries.html',
                        controller: 'itineraryCtrl',
                        controllerAs: 'vm',
                        'resolve' : {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['itinerary']);
                            }],
                            itineraries : ['itineraryService', '$stateParams', function(itineraryService, $stateParams){
                                return itineraryService.getItinerariesPage($stateParams.page, $stateParams.size);
                            }],
                            itinerariesDisabled : ['itineraryService', function(itineraryService){
                                return itineraryService.getItinerariesDisable();
                            }]
                        }
                    }
                }
            })
            .state('itineraryNew', {
                parent: 'app',
                url: '/itinerary/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/flightControl/itinerary/newItinerary.html',
                        controller: 'newItineraryCtrl',
                        controllerAs: 'vm',
                        'resolve' : {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['itinerary']);
                            }]
                        }
                    }
                }
            })
            .state('itineraryEdit', {
                parent: 'app',
                url: '/itinerary/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/flightControl/itinerary/editItinerary.html',
                        controller: 'editItineraryCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['itinerary']);
                            }],
                            itinerary: ['itineraryService', '$stateParams', function(itineraryService,$stateParams){
                                return itineraryService.getItinerary($stateParams.id);
                            }]
                        }
                    }
                }
            })
            .state('itineraryDisable', {
                parent: 'itineraryList',
                url: '/itinerary/:id/disable',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal','linkService', function($stateParams, $state, $uibModal,linkService) {
                    $uibModal.open({
                        templateUrl: 'app/admin/flightControl/itinerary/disableItinerary.html',
                        controller: 'disableItineraryCtrl',
                        controllerAs: 'vm',
                        size: 'sm',
                        resolve: {
                            itinerary: ['itineraryService', function(itineraryService){
                                return itineraryService.getItinerary($stateParams.id);
                            }]
                        }
                    }).result.then(function() {
                        linkService.reloadRoute('itineraryList');
                    }, function() {
                        linkService.reloadRoute('^');
                    });
                }]
            })
            .state('itineraryEnable', {
                parent: 'itineraryList',
                url: '/itinerary/:id/enable',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal','linkService', function($stateParams, $state, $uibModal,linkService) {
                    $uibModal.open({
                        templateUrl: 'app/admin/flightControl/itinerary/enableItinerary.html',
                        controller: 'enableItineraryCtrl',
                        controllerAs: 'vm',
                        size: 'sm',
                        resolve: {
                            itinerary: ['itineraryService', function(itineraryService){
                                return itineraryService.getItinerary($stateParams.id);
                            }]
                        }
                    }).result.then(function() {
                        linkService.reloadRoute('itineraryList');
                    }, function() {
                        linkService.reloadRoute('^');
                    });
                }]
            })
    }
})();
